import { useEffect, useState } from 'react'

export type Viewport = 'desktop' | 'mobile'

const MOBILE_BREAKPOINT_PX = 767

function getInitialViewport(): Viewport {
  if (typeof window === 'undefined') return 'desktop'
  return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT_PX}px)`).matches
    ? 'mobile'
    : 'desktop'
}

export function useViewport(): Viewport {
  const [viewport, setViewport] = useState<Viewport>(getInitialViewport)

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT_PX}px)`)
    const onChange = () => setViewport(mql.matches ? 'mobile' : 'desktop')
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [])

  return viewport
}
